import request from '@/plugins/axios'
//上传图片信息
export function uploadPic(data) {
  return request({
    url: '/file/uploadPic',
    method: 'post',
    data
  })
}

// //上传图片---(分片方式)第一步
// export function uploadPicChunk(params,data) {
//   return request({
//     url: '/file/uploadPicChunk',
//     method: 'post',
//     params,
//     data
//   })
// }

// //上传图片---(合并分片方式)第二步
// export function uploadPicChunkMerge(params) {
//   return request({
//     url: '/file/uploadPicChunkMerge',
//     method: 'post',
//     params
//   })
// }

//上传图片---(分片方式)第一步
export function uploadPicChunk(params,data) {
  return request({
    url: '/file/uploadChunk',
    method: 'post',
    params,
    data
  })
}

//上传图片---(合并分片方式)第二步
export function uploadPicChunkMerge(params) {
  return request({
    url: '/file/uploadChunkMerge',
    method: 'post',
    params
  })
}

//查询文件信息（通过id）
export function getFileInfoById(params) {
  return request({
    url: '/file/getFileInfoById/' + params,
    method: 'get'
  })
}

//查询文件信息（通过hash值就是md5）
export function getFileInfoByHash(params) {
  return request({
    url: '/file/getFileInfoByHash/' + params,
    method: 'get'
  })
}
export function setExtInfoapi(params,data) {
  console.log(data);
  return request({
    url: '/file/updateExtInfo',
    method: 'post',
    params,
    data
  })
}